/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function SessionDialogController($mdDialog, title, key, onSaved) {
    var vm = this;

    vm.$onInit = function () {
        vm.title = title;
        vm.key = key;
        vm.close = close;
        vm.save = save;

        vm.inputValidation = {
            rxDelay: {
                minValue: 0,
                maxValue: 15,
                pattern: /^-?[0-9]+$/
            },
            rx1DataRateOffset: {
                minValue: 0,
                pattern: /^-?[0-9]+$/
            },
            rx2DataRate: {
                minValue: -1,
                pattern: /^-?[0-9]+$/
            },
            rx2Frequency: {
                minValue: 0,
                maxValue: 1670,
                step: 0.001,
                frequencyConverter: true
            }
        };
    };

    function close () {
        $mdDialog.hide();
    }

    function save() {
        vm.theForm.$setPristine();
        if (onSaved) {
            onSaved(vm.newValue)
        }
        $mdDialog.hide();
    }
}



// WEBPACK FOOTER //
// ./src/app/network-settings/session-dialog/session-dialog.controller.js